import { Utils } from '../../app.base'
import { MsgBox, Vue, Routes } from '../../app.vues';

import SwbDevcAccClaimSave from './DevcAccClaimSave';
Vue.regist(SwbDevcAccClaimSave);

export function saveDevcAccClaimForDlg(params, callback) {
    let id = params.id || null;
    //
    let title = Utils.isNoB(id) ? "新增" : "编辑";
    let theDlg = Vue.$showDialog({
        title: "设备配件要求-" + title,
        width: 900,
        height: 800,
        template: '<swb-devc-acc-claim-save :id="id" :servcTypeId="servcTypeId" ref="swb_acc_claim_save"></swb-devc-acc-claim-save>',
        data: {
            id: id,
            servcTypeId: params.servcTypeId,
        },
        okClicked: function () {
            let result = this.$refs.swb_acc_claim_save.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbServcAccClaimSave from './ServcAccClaimSave';
Vue.regist(SwbServcAccClaimSave);

export function saveServcAccClaimForDlg(params, callback) {
    let id = params.id || null;
    //
    let title = Utils.isNoB(id) ? "新增" : "编辑";
    let theDlg = Vue.$showDialog({
        title: "服务配件要求-" + title,
        width: 900,
        height: 800,
        template: '<swb-servc-acc-claim-save :id="id" :servcTypeId="servcTypeId" ref="swb_servc_acc_claim_save"></swb-servc-acc-claim-save>',
        data: {
            id: id,
            servcTypeId: params.servcTypeId,
        },
        okClicked: function () {
            let result = this.$refs.swb_servc_acc_claim_save.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbBasicClaimForSelect from './BasicClaimForSelect';
Vue.regist(SwbBasicClaimForSelect);
/*
 multiSelect(是否多选)，isDevcFlag（是否设备），checkedItem（单选回显），selectIds（多选回显），servcTypeId（服务类型），
 servcCatId（服务分类），goodsCatId（商品分类），forAuthFlag（对内，对外）
 */
export function openBasicClaimForSelectDlg(params, callback) {
    let multiSelect = params['multiSelect'] != null ? params['multiSelect'] : false;
    let isDevcFlag = params['isDevcFlag'] != null ? params['isDevcFlag'] : false;
    let checkedItem = params['checkedItem'] != null ? params['checkedItem'] : null
    let selectIds = params['selectIds'] || [];
    let servcTypeId = params['servcTypeId'] != null ? params['servcTypeId'] : null; // 服务
    let goodsCatId = params['goodsCatId'] != null ? params['goodsCatId'] : null;
    let forAuthFlag = params['forAuthFlag'] != null ? params['forAuthFlag'] : false;
    let title = params['title'] != null ? params['title'] : '价格质量要求-选择';
    let goodsCatIds = params['goodsCatIds'] != null ? params['goodsCatIds'] : null;
    let allSearchFlag = params['allSearchFlag'];
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 900,
        template: '<swb-basic-claim-list-select :forAuthFlag="forAuthFlag" :isShowSelection="multiSelect" :isDevcFlag="isDevcFlag" :checkedItem="checkedItem" :selectIds="selectIds" :checkservcTypeId="servcTypeId" :goodsCatId="goodsCatId" :allSearchFlag="allSearchFlag" :goodsCatIds="goodsCatIds" ref="swb_basic_claim_list_select"></swb-basic-claim-list-select>',
        data: {
            multiSelect: multiSelect,
            isDevcFlag: isDevcFlag,
            checkedItem: checkedItem,
            selectIds: selectIds,
            servcTypeId: servcTypeId,
            goodsCatId: goodsCatId,
            forAuthFlag: forAuthFlag,
            allSearchFlag: allSearchFlag,
            goodsCatIds: goodsCatIds
        },
        okClicked: function () {
            let result = this.$refs.swb_basic_claim_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbAccClaimForSelect from './AccClaimForSelect';
Vue.regist(SwbAccClaimForSelect);
/*
 multiSelect(是否多选)，isDevcFlag（是否设备），checkedItem（单选回显），selectIds（多选回显），servcTypeId（服务类型），
 servcCatId（服务分类），goodsCatId（商品分类），forAuthFlag（对内，对外）
 */
export function openAccClaimForSelectDlg(params, callback) {
    let multiSelect = params['multiSelect'] != null ? params['multiSelect'] : false;
    let isDevcFlag = params['isDevcFlag'] != null ? params['isDevcFlag'] : false;
    let checkedItem = params['checkedItem'] != null ? params['checkedItem'] : null;
    let selectIds = params['selectIds'] || [];
    let servcTypeId = params['servcTypeId'] != null ? params['servcTypeId'] : null; // 服务
    let goodsCatId = params['goodsCatId'] != null ? params['goodsCatId'] : null;
    let forAuthFlag = params['forAuthFlag'] != null ? params['forAuthFlag'] : false;
    let title = params['title'] != null ? params['title'] : '配件要求-选择';
    let goodsCatIds = params['goodsCatIds'] != null ? params['goodsCatIds'] : null;
    let allSearchFlag = params['allSearchFlag'];
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 900,
        template: '<swb-acc-claim-list-select :forAuthFlag="forAuthFlag" :isShowSelection="multiSelect" :isDevcFlag="isDevcFlag" :checkedItem="checkedItem" :selectIds="selectIds" :checkservcTypeId="servcTypeId" :goodsCatId="goodsCatId" :allSearchFlag="allSearchFlag" :goodsCatIds="goodsCatIds" ref="swb_acc_claim_list_select"></swb-acc-claim-list-select>',
        data: {
            multiSelect: multiSelect,
            isDevcFlag: isDevcFlag,
            checkedItem: checkedItem,
            selectIds: selectIds,
            servcTypeId: servcTypeId,
            goodsCatId: goodsCatId,
            forAuthFlag: forAuthFlag,
            allSearchFlag: allSearchFlag,
            goodsCatIds: goodsCatIds
        },
        okClicked: function () {
            let result = this.$refs.swb_acc_claim_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/servcClaim/selectDlg.js
// module id = 236
// module chunks = 1